import { Paper, PaperProps } from '@mui/material';
import React from 'react';

export const BTPaperProps = {
};

export const BTPaper = React.forwardRef(({ children, ...props }: PaperProps, ref: any) => {
    return <Paper ref={ref} sx={{
        ...props.sx,
        ...BTPaperProps,
    }} {...props}>{children}</Paper>
});
